export const checkIsFloat = (n: number) => Number(n) === n && n % 1 !== 0;

export const getUpdatedNumber = (n: number) => {
  try {
    const isFloat = checkIsFloat(n);
    return isFloat ? n.toFixed(2) : n;
  } catch (e) {
    console.log("Error in getUpdatedNumber", e);
  }
  return 0;
};
